'use strict';
/**
 * @author Maxim Seredkin
 */
export default function projectMaintenanceKindTable() {
    return {
        restrict: 'A',
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            project: '=myProject',
            edit: '=edit'
        },
        template: require('../../../../../view/table.html'),
        transclude: false,
        controller: ['$scope', '$utils', 'MaintenanceKindService',
            function ($scope, $utils, MaintenanceKindService) {

                $scope.select = select;
                $scope.refresh = refresh;
                $scope.dblClick = dblClick;
                $scope.isSelect = isSelect;
                $scope.getItems = getItems;
                $scope.getValue = $utils.getValue;

                init();

                // region Function

                function init() {
                    if (!$scope.selectedItem)
                        $scope.selectedItem = {};

                    $scope.columns = [{
                        name: 'Наименование',
                        data: 'name',
                    }];

                    $scope.searching = {
                        isSearch: $scope.isSearch,
                        filter: null
                    };

                    $scope.pagination = {
                        isPaging: $scope.isPaging,
                        page: 1,
                        size: $scope.isPaging ? 10 : null,
                        totalPages: null,
                        totalItems: null
                    };

                    $scope.toolbox = {
                        buttons: {
                            create: {
                                show: () => $scope.edit,
                                click: () => {
                                    MaintenanceKindService.select({}).result.then(function (data) {
                                        if (!$scope.items.some(item => equals(item, data))) {
                                            $scope.items.push(data);
                                        }
                                    });
                                },
                                disabled: () => false,
                            },
                            remove: {
                                show: () => $scope.edit,
                                click: (item) => {
                                    $scope.project.projectMaintenances = $scope.project.projectMaintenances.filter((maintenance) => !angular.equals(maintenance.maintenanceKind.id, item.id));
                                    $scope.items.splice($scope.items.indexOf($scope.items.find(it => equals(it, item))), 1);
                                    if (!$scope.items.length) {
                                        $scope.project.projectMaintenances = [];
                                    }
                                    if (Array.isArray($scope.items) && ($scope.items.length > 0)) {
                                        $scope.selectedItem = angular.copy($scope.items[0]);
                                    }
                                },
                                disabled: () => !isSelected(),
                            },
                            refresh: {
                                show: () => false,
                                click: $scope.refresh,
                                disabled: () => false,
                            },
                        }
                    };

                    refresh();
                }

                function refresh() {
                    if (Array.isArray($scope.items)) {
                        if ($scope.items.every(i => !equals(i, getSelected()))) {
                            $scope.selectedItem = {};
                        }
                        if (($scope.items.length > 0) && !isSelected()) {
                            $scope.selectedItem = angular.copy($scope.items[0]);
                        }
                    }
                }

                function dblClick(item) {
                    switch ($scope.type) {
                        case 'table' :
                            if ($scope.toolbox.buttons.edit) {
                                $scope.toolbox.buttons.edit.click(item);
                            }
                            break;
                        case 'select' :
                            $scope.ok();
                            break;
                    }
                }

                function select(item) {
                    if (!$scope.isSelect(item)) {
                        angular.copy(item, $scope.selectedItem);
                    }
                }

                function isSelect(item) {
                    return equals($scope.selectedItem, item);
                }

                function isSelected() {
                    return $scope.selectedItem != null && $scope.selectedItem.id != null;
                }

                function getSelected() {
                    return $scope.selectedItem;
                }

                function equals(i1, i2) {
                    if (i1 == null || i2 == null) {
                        return false;
                    }
                    return ((i1.id == i2.id));
                }

                function getItems() {
                    return $scope.items;
                }

                // endregion

                // region Watcher

                $scope.$watch('items', function () {
                    refresh();
                });

                // endregion

            }]
    };
}